import { trackEvent } from '@/utils/analytics'
export default {
  methods: {
    goToNote(noteIds, appendToBreadcrumb = false, event = {}, options = {}) {
      if (!event.ctrlKey) {
        const contextion = this.getContextion(noteIds, appendToBreadcrumb)
        this.$store.dispatch('setViewMode', this.$store.state.defaultViewMode)
        trackEvent('open note', {
          eventCategory: 'notes',
          eventAction: 'open'
        })
        this.$router.push({ name: 'noteByContextion', params: { contextion } }).catch(err => console.log(err))
      }
      if (options.toggleSideBar) this.$store.dispatch('setSideBarCollapsed', !this.$store.state.sideBarCollapsed)
    },
    getContextion(noteIds, appendToBreadcrumb = false) {
      if (!Array.isArray(noteIds)) noteIds = [noteIds]
      const breadcrumb = this.$store.getters.breadcrumb
      const newBreadcrumb = appendToBreadcrumb ? [...breadcrumb, ...noteIds] : noteIds
      const contextion = btoa(newBreadcrumb.join(';'))
      return contextion
    }
  }
}
